// Полоса формы W/L/D/N. Буквы — серверные; неизвестная рисуется как есть.
import styles from './FormStrip.module.css';

export function FormStrip({ form }: { form: string[] }) {
  return (
    <span className={styles.strip}>
      {form.map((r, i) => <span key={i} className={`${styles.cell} ${styles[r] ?? ''}`}>{r}</span>)}
    </span>
  );
}
